import { Routes, Route } from "react-router-dom";
import LoginPage from "./components/Login/LoginPage";
import Layout from "./components/Layout/Layout";
import ChatPage from "./components/Dashboard/Home/ChatPage";
import NotFound from "./components/ErrorBoundary/NotFound";
import { useAppContext } from "./context/AppContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";




const AppRoutes = ({ hasPayload }) => {
    const { isAuthenticated } = useAppContext();
    const navigate = useNavigate();
    const { search } = useLocation();

    useEffect(() => {
        if (hasPayload) {
            const urlParams = new URLSearchParams(search);
            const payload = urlParams.get("payload");
            // navigate("/login", { state: { payload } });
            navigate("/login", { state: { payload }, replace: true });
        }
    }, [hasPayload]);

    return (
        <Routes>
            {/* Login */}
            <Route
                path="/login"
                element={<LoginPage onLogin={() => { }} />}
            />
            {/* Main App */}
            <Route
                path="/"
                element={
                    isAuthenticated ? (
                        <Layout />
                    ) : (
                        <LoginPage onLogin={() => { }} />
                    )
                }
            >
                <Route index element={<ChatPage />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

AppRoutes.propTypes = {
    hasPayload: PropTypes.bool,
};

export default AppRoutes;